import React from 'react';

const TraitSelector = ({ onSelect, label, values, currentValue, n, valueMask }) => {
    const selectId = `trait${n}value`;
    return (
        <div className='form-group'>
            <div className='col-xs-12'>
                <label className={`trait${n}-label`} htmlFor={selectId}>{label}*</label>
                <select
                    id={selectId}
                    className="form-control"
                    value={currentValue === null ? '' : currentValue}
                    onChange={(e) => onSelect(Number.parseInt(e.target.value))}
                >
                    <option key={-1} value={''}>{'Select'}</option>
                    {values.map(
                        (val, i) =>
                            valueMask[i]
                                ? <option key={i} value={i}>{val}</option>
                                : null)}
                </select>
            </div>
        </div>
    );
};

export default TraitSelector;